import React, { Component } from 'react';

class GruposAfinidadCabal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let data = this.props.data;
      
        if (data) {
            var branchesNodes = data.map((afinidadItem) => {
                return (
                    <div key={"checkAfinidad" + afinidadItem.Id} className="row">
                        <div key={"checkAfinidad" + afinidadItem.Id} className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                    <div className="default-checkbox">
                                        <input key={"checkAfinidad" + afinidadItem.Id}
                                            id={"checkAfinidad" + afinidadItem.Id}
                                            name="checkAfinidad"
                                            type="checkbox"
                                            checked={afinidadItem.Checked}
                                            onChange={() => this.props.checkItem(afinidadItem.Id)}
                                            value={afinidadItem.Checked} Checked />
                                        <label className="label-primary"
                                            htmlFor={"checkAfinidad" + afinidadItem.Id}></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary"
                                        htmlFor={"checkAfinidad" + afinidadItem.Id}>
                                        {afinidadItem.Codigo + " - " + afinidadItem.Descripcion}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                )
            })
        }
        return (
            data != undefined &&
            <div className="row top-separator-xs vertical-scrollable-container-md">
                <div className="col-md-12">
                    {branchesNodes}                    
                </div>
            </div>
        );
    }
};

export default GruposAfinidadCabal;